module.exports = __webpack_public_path__ + "media/images/btn_download_stations-96367f73c76cf17285fda0f3b2693f86.gif";